const initialFilterState = () => {
  return {
    startDate: null,
    endDate: null,
    orderBy: "createdAt",
    order: "desc",
  };
};

export default initialFilterState;
